import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/fontawesome-free-solid";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import popupStyles from "../contactus/viewPopup.module.scss";
import styles from "./viewCampaignSupportPopup.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import { REACT_APP_API_CAMPAIGN_SUPPORT } from "../../redux/apiConstants";
import PropTypes from "prop-types";
import Loader from "../../components/Loader/Loader";

const ViewCampaignSupportPopup = React.memo(({ supportId, handleClose }) => {
  const { formthemeStyle, bodyheader, viewformStyle } = useContext(TableContext);
  const token = `Bearer ${getCookies("Token")}`;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({});
  const dateFormat = getCookies("dateFormat");

  const getDetails = async () => {
    setLoading(true);
    axios
      .get(`${REACT_APP_API_CAMPAIGN_SUPPORT}/${supportId}`, {
        headers: { Authorization: token },
      })
      .then((resp) => resp.data)
      .then((res) => {
        setDetails(res?.data?.request || {});
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getDetails();
  }, [supportId]);

  const value = (text) => (text && String(text).trim() ? text : "NA");

  const Field = ({ label, children, wide = false }) => (
    <div
      className={`${popupStyles[viewformStyle]} ${styles.field} ${wide ? styles.wide : ""}`}
    >
      <span className={styles.title}>{label}</span>
      <p className={styles.value}>{children}</p>
    </div>
  );

  return (
    <div className={popupStyles.popupbox}>
      <div className={`${popupStyles[formthemeStyle]} ${styles.box}`}>
        <span
          className={popupStyles.closeicon}
          role="button"
          tabIndex={0}
          onClick={handleClose}
          onKeyPress={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </span>
        {loading ? (
          <Loader centered />
        ) : (
          <>
            <h5 className={`${popupStyles[bodyheader]} ${styles.heading}`}>
              Campaign Support Request
            </h5>
            <div className={styles.grid}>
              <Field label="Topic">{value(details.topicLabel || details.topic)}</Field>
              <Field label="Email">{value(details.email)}</Field>
              <Field label="Phone">{value(details.phone)}</Field>
              <Field label="City">{value(details.city)}</Field>
              <Field label="Café name">{value(details.cafeName)}</Field>
              <Field label="Campaign">{value(details.campaignName)}</Field>
              <Field label="Message" wide>
                <span style={{ whiteSpace: "pre-wrap" }}>{value(details.message)}</span>
              </Field>
              <Field label="Submitted">
                {details.createdAt
                  ? DateFormatter(details.createdAt, dateFormat || "MonthDayYear")
                  : "NA"}
              </Field>
            </div>
          </>
        )}
      </div>
    </div>
  );
});

ViewCampaignSupportPopup.propTypes = {
  supportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ViewCampaignSupportPopup;
